import React from 'react';

const PageContent = (props) => {

  return (
    <div>
      {props.children}
    </div>
  );
};

export default PageContent;
